import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import HomePage from './pages/HomePage';
import RegisterExpert from './pages/RegisterExpert';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import ExpertProfile from './pages/ExpertProfile';
import { ExpertProvider } from './context/ExpertContext';
import { AdminProvider } from './context/AdminContext';
import { LanguageProvider } from './context/LanguageContext';

function App() {
  return (
    <LanguageProvider>
      <ExpertProvider>
        <AdminProvider>
          <Router>
            <div className="min-h-screen bg-slate-50">
              <Header />
              <main>
                <Routes>
                  <Route path="/" element={<HomePage />} />
                  <Route path="/register" element={<RegisterExpert />} />
                  <Route path="/admin" element={<AdminLogin />} />
                  <Route path="/admin/dashboard" element={<AdminDashboard />} />
                  <Route path="/expert/:id" element={<ExpertProfile />} />
                </Routes>
              </main>
            </div>
          </Router>
        </AdminProvider>
      </ExpertProvider>
    </LanguageProvider>
  );
}

export default App;